import * as CountryFlags from 'country-flag-icons/react/3x2';

import type { CountryCode } from '@/constants/country';
import { cn } from '@/lib/cn';

export interface CountryFlagProps {
  /** ISO 3166-1 alpha-2 形式の国コード */
  // oxlint-disable-next-line typescript/no-redundant-type-constituents -- 未知の国コードも受け入れる
  countryCode: CountryCode | string;
  /** 追加のクラス名 */
  className?: string;
  /** アクセシビリティ用のタイトル */
  title?: string;
}

/**
 * 国旗SVGコンポーネント
 *
 * @example
 * ```tsx
 * <CountryFlag countryCode="JP" />
 * <CountryFlag countryCode="US" className="h-5" />
 * ```
 */
export const CountryFlag = ({
  countryCode,
  className,
  title = '',
}: CountryFlagProps) => {
  const FlagComponent = (
    CountryFlags as Record<string, typeof CountryFlags.JP | undefined>
  )[countryCode];

  if (!FlagComponent) {
    return null;
  }

  return (
    <FlagComponent
      className={cn(
        'h-4 rounded-sm shrink-0 border border-neutral-muted-border/5',
        className,
      )}
      title={title}
    />
  );
};
